module.exports = __webpack_public_path__ + "static/assets/6ef1755060e415b556609de5d572463f.gif";